module.exports = __webpack_public_path__ + "static/media/35.8c16f4a7.gif";